import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';
import type { VisitorInfoSection } from '@/types/visitorInfo';

export interface PublicVisitorInfo {
  sections: VisitorInfoSection[];
}

export function usePublicVisitorInfo() {
  const [visitorInfo, setVisitorInfo] = useState<PublicVisitorInfo | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    const fetchVisitorInfo = async () => {
      try {
        setLoading(true);
        setError(null);

        const { data, error: fetchError } = await supabase
          .from('visitor_info')
          .select('*')
          .eq('id', 1)
          .single();

        if (fetchError) {
          throw fetchError;
        }

        if (data) {
          const transformedData: PublicVisitorInfo = {
            sections: (data.sections as any as VisitorInfoSection[]) || [],
          };
          
          setVisitorInfo(transformedData);
        }
      } catch (err) {
        console.error('Error fetching public visitor info:', err);
        setError(err instanceof Error ? err : new Error('Unknown error'));
        
        // Fallback to empty sections if database fails
        setVisitorInfo({ sections: [] });
      } finally {
        setLoading(false);
      }
    };

    fetchVisitorInfo();
  }, []);

  return { visitorInfo, loading, error };
}